export const tabs = ({ count, theme: { colors } }) => ({
    display: 'grid',
    gridTemplateColumns: `repeat(${count}, 1fr)`,
    alignItems: 'center',
    borderBottom: `1px solid ${colors.blueGrey1}`,
    marginBottom: -1,
});
